// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__r6GHm","modal-show":"Modal_modal-show__O-BvH","openModal":"Modal_openModal__S+iHy","modal-bg-show":"Modal_modal-bg-show__wqH4a"};